import { useState } from 'react';

export default function useToggle(initialValue: boolean = false) {
  const [value, setValue] = useState(initialValue);

  const toggle = () => setValue(prevValue => !prevValue);

  return { value, toggle };
}
